import React, { Component } from 'react'
import { connect } from 'react-redux';
import { translate } from 'react-multi-lang'

class Employment extends Component {

    componentDidMount() {
        document.title = 'Screen Reader';
    }
    render() {
        const currentLang = localStorage.getItem('language') || 'en';

        const data = [
            {
                name: {
                    en: "Screen Access For All (SAFA)",
                    hi: "सभी के लिए स्क्रीन एक्सेस (SAFA)",
                    pa: "ਸਭ ਲਈ ਸਕਰੀਨ ਐਕਸੈੱਸ (SAFA)"
                },
                link1: "http://safa-reader.software.informer.com/download/",
                type: {
                    en: "Free",
                    hi: "निःशुल्क",
                    pa: "ਮੁਫ਼ਤ"
                }
            },
            {
                name: {
                    en: "Non Visual Desktop Access (NVDA)",
                    hi: "नॉन विज़ुअल डेस्कटॉप एक्सेस (NVDA)",
                    pa: "ਨਾਨ ਵਿਜੁਅਲ ਡੈਸਕਟਾਪ ਐਕਸੈੱਸ (NVDA)"
                },
                link1: "http://www.nvda-project.org/",
                type: {
                    en: "Free",
                    hi: "निःशुल्क",
                    pa: "ਮੁਫ਼ਤ"
                }
            },
            {
                name: {
                    en: "System Access To Go",
                    hi: "सिस्टम एक्सेस टू गो",
                    pa: "ਸਿਸਟਮ ਐਕਸੈੱਸ ਟੂ ਗੋ"
                },
                link1: "http://www.satogo.com/",
                type: {
                    en: "Free",
                    hi: "निःशुल्क",
                    pa: "ਮੁਫ਼ਤ"
                }
            },
            {
                name: {
                    en: "Thunder",
                    hi: "थंडर",
                    pa: "ਥੰਡਰ"
                },
                link1: "http://www.screenreader.net/index.php?pageid=2",
                type: {
                    en: "Commercial",
                    hi: "व्यावसायिक",
                    pa: "ਵਪਾਰਕ"
                }
            }
        ];

        return (
            <div className="tab-content">
                <div id="home" className=" tab-pane active">
                    <section className="login-form mt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 p-0 mx-auto  tab-content border-0 cover-shadow   mb-3 mt-5  bg-white">
                                    <div className="panel-heading classredius">
                                        <h6 className="mb-0">{this.props.t("secreenReder.main_heading", { param: "react" })}</h6>
                                    </div>
                                    <div className="panel-body p-policy pt-0  p-3 ">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="table-responsive testable">

                                                    <div className="maintablebox">
                                                        <h2>{this.props.t("secreenReder.heading", { param: "react" })}</h2>
                                                        <p>
                                                            {this.props.t("secreenReder.at", { param: "react" })} <strong>{this.props.t("secreenReder.line1", { param: "react" })}</strong>,{this.props.t("secreenReder.punjab_rojgar", { param: "react" })}
                                                        </p>
                                                        <p>
                                                            {this.props.t("secreenReder.line2", { param: "react" })}
                                                        </p>
                                                        <p>
                                                            {this.props.t("secreenReder.line3", { param: "react" })}
                                                        </p>
                                                        <p>
                                                            {this.props.t("secreenReder.line4", { param: "react" })}
                                                        </p>
                                                        <p>
                                                            {this.props.t("secreenReder.line5", { param: "react" })}
                                                            <strong> {this.props.t("secreenReder.pgrkam_email", { param: "react" })} </strong>.
                                                        </p>

                                                        <h4>{this.props.t("secreenReder.heading2", { param: "react" })}</h4>
                                                        <p>
                                                            {this.props.t("secreenReder.line6", { param: "react" })}
                                                        </p>
                                                        <p>
                                                            {this.props.t("secreenReder.line7", { param: "react" })}
                                                        </p>

                                                        <h4> {this.props.t("secreenReder.heading3", { param: "react" })}</h4>
                                                    </div>



                                                    {/* <h2>Screen Reader Access</h2>
                                                       <p>  This feature will enable people with visual impairments access the website using Assistive Technologies, such as screen readers. 
                                                           The information of this website is accessible with different screen readers, as mentioned below:
                                                        </p> */}
                                                    <table className="table table-striped tableclass">
                                                        <thead>
                                                            <tr>
                                                                <th width="5%">{this.props.t("secreenReder.sr_no", { param: "react" })}</th>
                                                                <th width="30%">{this.props.t("secreenReder.screen_reader", { param: "react" })}</th>
                                                                <th width="40%">{this.props.t("secreenReder.website", { param: "react" })}</th>
                                                                <th width="25%">{this.props.t("secreenReder.free", { param: "react" })}</th>
                                                                {/* <th width="20%">If you want to register as a labourer, go to the link of your location/ District.</th>
                                                                <th width="20%">For getting help regarding registration as labourer/ employer, please contact the following Email of your location/ District</th>
                                                                <th width="20%">For getting help regarding registration as labourer/ employer, please contact the following Helpline No. of your location/ District</th> */}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {data && data.map((d, key) => {
                                                                return (
                                                                    <tr key={key}>
                                                                        <td>{key + 1}</td>

                                                                        {/* Access multi-language name */}
                                                                        <td>{d.name && d.name[currentLang] ? d.name[currentLang] : ''}</td>

                                                                        {/* Website link */}
                                                                        <td>
                                                                            <a
                                                                                aria-label='Visit Screen Reader link'
                                                                                rel="noopener noreferrer"
                                                                                target="_blank"
                                                                                href={d.link1}
                                                                            >
                                                                                {d.link1}
                                                                            </a>
                                                                        </td>

                                                                        {/* Access multi-language type */}
                                                                        <td>{d.type && d.type[currentLang] ? d.type[currentLang] : ''}</td>
                                                                    </tr>
                                                                );
                                                            })}

                                                        </tbody>

                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => {
    return store;
};
export default connect(mapStateToProps)(translate(Employment));
